export default __webpack_public_path__ + "static/media/2_roadmap.0076b6d9.jpg";